import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import style from "./SnappShopColoredFilters.module.scss";
import toPersianNumber from "../../../helpers/actions/toPersianNumber"

const SnappShopColoredFilters = (props) => {
    const [isFilterSelected, setIsFilterSelected] = useState(false)

    useEffect(() => {
        if (props.filters) {
            Object.keys(props.filters).map(el => {
                if (props.filters[el].selected) {
                    setIsFilterSelected(true)
                }
            })
        }
    }, [props.filters])

    const defineFilterName = (filter) => {
        let name = ''
        switch (filter) {
            case 'inBuyBox':
                name = 'تنوع در باکس'
                break;
            case 'outOfBox':
                name = 'تنوع خارج از باکس'
                break;
            case 'hasError':
                name = 'تنوع خطادار'
                break;
            case 'deactive':
                name = 'تنوع غیرفعال در ربات'
                break;
        }
        return name
    }

    return (
        <div className={style.wrapper}>
            {Object.keys(props.filters).map((colorFilter, colorFilterIndex) => <div
                key={`colorFilterIndex_${colorFilterIndex}`}
                className={`${style.generalFrame} ${style[`${colorFilter}${props.filters[colorFilter].selected ? 'Selected' : ''}`]}`}
                onClick={() => props.handleChangeFilters(props.filters[colorFilter].tag, props.filters[colorFilter].selected)}
            >
                {toPersianNumber(props.filters[colorFilter].value)} {defineFilterName(colorFilter)}
            </div>)}
            {isFilterSelected && <div
                className={`${style.generalFrame} ${style.showAll}`}
                onClick={props.handleDeleteAll}
            >
                نمایش همه تنوع‌ها
            </div>}
        </div>
    )
}

export default withRouter(SnappShopColoredFilters);



